const XICon = ({ className = "", fill = "#BABABA" }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 10.0373L4.8886 14.25L3.75 13.0833L7.8614 8.8706L4.00257 4.91667L5.14117 3.75L9 7.70394L12.8588 3.75L13.9974 4.91667L10.1386 8.8706L14.25 13.0833L13.1114 14.25L9 10.0373Z"
        fill={fill}
      />
    </svg>
  );
};

export default XICon;
